import PropTypes from 'prop-types';
import React from 'react';

import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import useSearchResultsContext from 'dpl/puppy_search_results/hooks/useSearchResultsContext';

import useSearchFiltering from '../hooks/useSearchFiltering';
import FilterButtonActions from './FilterButtonActions';
import SearchFilters from './SearchFilters';

export default function FiltersModal({ totalItemCount }) {
  const { isFiltersModalOpen, toggleFilters, resultsType } =
    useSearchFiltering();
  const { sendBreedSearchedAnalytics } = useSearchResultsContext();

  if (!isFiltersModalOpen) return null;

  function handleApplyFilters() {
    toggleFilters();
    sendBreedSearchedAnalytics();
  }

  return (
    <MiniOverlayModal
      className="FiltersModal"
      closeButtonClassName="FiltersModal__close fixed absolute-m absolute-l ba b--light-gray bg-white br-100 padding-h-6 padding-v-6 mt5 mt6-md mr4 mr6-md"
      contentClassName="flex-ns flex-column relative bg-white overflow-y-hidden-ns"
      maxWidth="780px"
      onCloseClick={handleApplyFilters}
      scrollableContent
    >
      <div className="pt4 pt6-md pb3 pb1-md ph5 ph12-md br4 br--top bb bb-0-ns b--light-gray">
        <h4 className="font-24 md:font-32">All filters</h4>
      </div>
      <div className="flex-auto overflow-y-auto">
        <SearchFilters className="pv5 ph5 ph12-md mb6-md" />
      </div>
      <FilterButtonActions
        className="sticky bottom-0 justify-between pv4 ph5 ph12-md bg-white bt b--default"
        setIsMenuOpen={toggleFilters}
        totalItemCount={totalItemCount}
        resultsType={resultsType}
        resetButtonText="Clear filters"
      />
    </MiniOverlayModal>
  );
}

FiltersModal.propTypes = {
  totalItemCount: PropTypes.number.isRequired
};
